














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Mapbox from 'mapbox-gl';
import { MglMap } from 'vue-mapbox';
import mapStyle from '@/assets/style.json';
import RequestService from '@/services/request.service';
import HelperService from '@/services/helper.service';
import MapService from '@/services/map.service';
import { Community, BMNCity, MapEvent, BicycleRoute, Project } from '@/interfaces';
import { Observable, Observer } from 'rxjs';
import DataService from '../services/data.service';

@Component({
  components: {
    MglMap,
  },
})
export default class BmnMap extends Vue {
  public mapbox: any;
  public accessToken = 'pk.eyJ1IjoiYXRjYXMiLCJhIjoiY2swZjBkdzFnMDB2eTNocXNhdjhvd3R6MSJ9.8TdRjPV6dJkvXpdGGdyaNw';
  public mapStyle = mapStyle;
  public layers = this.mapStyle.layers;
  public min: number;
  public max: number;
  public zoomLvl: number;

  @Prop()
  public communitiesVisible: boolean;
  @Prop()
  public bRoutesVisible: boolean;
  @Prop()
  public mirtVisible: boolean;
  @Prop()
  public bereikbaarheidsakkoordVisible: boolean;

  @Prop()
  public routes: BicycleRoute[];
  @Prop()
  public communities: Community[];
  @Prop()
  public locations: BMNCity[];
  @Prop()
  public projects: Project[];

  public maxBounds =  new Mapbox.LngLatBounds(
        new Mapbox.LngLat(3.6, 51),
        new Mapbox.LngLat(6.176430, 51.928139),
      ).toArray();
  private map: any;
  private rService = new RequestService();
  private helperService = new HelperService();
  private dataService = new DataService();
  private mapService = new MapService();
  private popup: any;

  public mounted() {
    setTimeout(() => {
      this.setMap(this.$refs.map);
    }, 500);
  }

  public data() {
    return {
      zoomLvl: this.zoomLvl,
      min: this.min,
      max: this.max,
      maxBounds: this.maxBounds
    };
  }

  @Watch('$route', { immediate: true, deep: true })
  public onUrlChange(newVal: any) {
    const comId = newVal.hash.replace('#', '');
    if (comId === '' ) {
      return;
    }
    this.mapService.stageTwoPopover(this.map, comId);
  }

  @Watch('communitiesVisible')
  private onCommunitiesChanged(value: boolean, oldValue: boolean) {
    this.mapService.toggleItems(value, this.communities, this.map);
  }

  @Watch('bRoutesVisible')
  private onRoutesChanged(value: boolean, oldValue: boolean) {
    this.mapService.toggleItems(value, this.routes, this.map);
    this.mapService.toggleItems(value, this.locations, this.map);
  }

  @Watch('mirtVisible')
  private onMirtChanged(value: boolean, oldValue: boolean) {
    const items = this.getItems('mirt');
    this.mapService.toggleItems(value, items, this.map);
  }

  @Watch('bereikbaarheidsakkoordVisible')
  private onAkkoordChanged(value: boolean, oldValue: boolean) {
    const items = this.getItems('bereikbaarheidsakkoord');
    this.mapService.toggleItems(value, items, this.map);
  }

  private getItems(projectId: string): Array<{id: string}> {
    const items = [];
    let projects;
    if (projectId === 'mirt') {
      projects = this.projects.filter(proj => {
        return proj.id === 'mirt';
      });
    } else {
      projects = this.projects.filter(proj => {
        return proj.id !== 'mirt';
      });
    }
    projects.forEach(proj => {
      items.push({id: `${proj.id}`});
      items.push({id: `symbol-${proj.id}`});
    });
    return items;
  }

  private updateBounds(): void {
    if (this.helperService.isMobile() || window.innerWidth <= 1024) {
      this.min = 4.5;
      this.max = 10;
      this.zoomLvl = this.min;
      this.maxBounds =  new Mapbox.LngLatBounds(
        new Mapbox.LngLat(3.221086, 50.782985),
        new Mapbox.LngLat(6.276521, 52.194797),
      ).toArray();
      return;
    }
    this.min = 4.5;
    this.max = 11;
    this.zoomLvl = this.min;
    this.maxBounds =  new Mapbox.LngLatBounds(
        new Mapbox.LngLat(2.74, 50.986099),
        new Mapbox.LngLat(6.799164, 51.983189),
      ).toArray();
  }

  private setMap(map: any): void {
    if (!map.map) {
      setTimeout(() => {
        this.setMap(map);
      }, 500);
      return;
    }
    this.map = map.map;
    this.map.dragRotate.disable();
    this.map.touchZoomRotate.disableRotation();
    this.mapService.setCommunityEvents(this.communities, this.map);
    this.mapService.setRouteEvents(this.routes, this.map);
    this.mapService.setLocationEvents(this.locations, this.map);
    this.mapService.setProjectEvents(this.projects, this.map);
    this.updateBounds();
    window.addEventListener('resize', this.updateBounds);
    this.prepareMap()
      .subscribe(() => {
        this.$emit('loaded');
      });

    this.map.on('click', () => {
      this.emitInteraction();
    });
    this.map.on('zoom', () => {
      this.emitInteraction();
    });
    this.map.on('dragstart', () => {
      this.emitInteraction();
    });
  }

  private emitInteraction() {
    if (this.helperService.isMobile()) {
      this.$emit('interacted');
    }
  }

  private prepareMap(): any {
    const observable = Observable.create((observer: Observer<any>) => {
      this.mapService.addUiElements(this.map, this.routes, this.locations, this.communities, this.projects)
        .subscribe(() => {
          observer.next('complete');
          observer.complete();
        });
    });
    return observable;
  }
}
